<template>
    <div class="card" v-show="sessions !== null">

        <div class="card-header">
            <div class="row">
                <div class="col-12">
                    <h3 class="mb-0 text-uppercase">{{ $t('warnings.sessions') }}</h3>
                </div>
            </div>
        </div>

        <p class="card-body pt-3 mb-0 text-sm" v-if="empty">{{ $t('sessions.no-session') }}</p>

        <div v-if="!empty">
            
            <el-table class="table-responsive table-flush"
                    :show-header="false"
                    :data="sessions">

                <el-table-column class-name="avatar-cell">
                    <template v-slot="{row}">

                        <div class="avatar-group">
                            <a href="#" @click.prevent="openOrEditLearner(row.learner1, row)" class="avatar rounded-circle" v-if="row.learner1">
                                <img :src="row.learner1.avatar">
                            </a>
                            <a href="#" @click.prevent="openOrEditLearner(row.learner2, row)" class="avatar rounded-circle" v-if="row.learner2">
                                <img :src="row.learner2.avatar">
                            </a>
                        </div>
                        <h5 class="mb-1" v-if="row.learner1">
                            <a href="#" @click.prevent="openOrEditLearner(row.learner1, row)">
                                {{ row.learner1.name }}
                            </a>
                        </h5>
                        <h5 class="mb-0" v-if="row.learner2">
                            <a href="#" @click.prevent="openOrEditLearner(row.learner2, row)">
                                {{ row.learner2.name }}
                            </a>
                        </h5>

                    </template>
                </el-table-column>

                <el-table-column>
                    <template v-slot="{row}">

                        <div>
                            <strong> {{ row.registration.degree.name }} > {{ row.simulation.name }} </strong>
                        </div>
                        <div>
                            <i class="fas fa-calendar-alt mr-1"></i> {{ date(row) }}
                        </div>

                    </template>
                </el-table-column>

                <el-table-column>
                    <template v-slot="{row}">

                        <!-- Learner 1 -->
                        
                        <div v-if="row.learner1">
                            <div class="text-danger" v-if="!row.learner1.state.published">
                                <i class="fas fa-exclamation-triangle mr-1"></i>
                                <strong> {{ row.learner1.name}}: </strong> {{ $t('warnings.unclosed') }}
                            </div>

                            <div class="text-warning" v-else-if="!row.learner1.state.acknowledged">
                                <i class="fas fa-exclamation-triangle mr-1"></i>
                                <strong> {{ row.learner1.name}}: </strong> {{ $t('warnings.unsigned') }}
                            </div>
                        </div>

                        <!-- Learner 2 -->
                        
                        <div v-if="row.learner2">
                            <div class="text-danger" v-if="!row.learner2.state.published">
                                <i class="fas fa-exclamation-triangle mr-1"></i>
                                <strong> {{ row.learner2.name}}: </strong> {{ $t('warnings.unclosed') }}
                            </div>

                            <div class="text-warning" v-else-if="!row.learner2.state.acknowledged">
                                <i class="fas fa-exclamation-triangle mr-1"></i>
                                <strong> {{ row.learner2.name}}: </strong> {{ $t('warnings.unsigned') }}
                            </div>
                        </div>

                    </template>
                </el-table-column>

                <el-table-column class-name="actions" align="right" width="120">
                    <template v-slot="{row}">
                        <div class="p-1">

                            <base-button type="primary" size="sm" @click="openSummary(row)"
                                class="mr-1 ml-1 mb-1"
                            >
                                {{ $t('dashboard.more') }}
                            </base-button>

                            <a href="#" class="table-action text-danger" @click.prevent="forgetNotification(row)">
                                <i class="tim-icons icon-simple-remove"></i>
                            </a>

                        </div>
                    </template>
                </el-table-column>
                
            </el-table>
        </div>
    </div>
</template>

<script>
    import moment from 'moment'

    export default {

        data() {
            return {
                endpoint: '/astral/api/front/dashboard/warnings',
                sessions: null,
                moment: moment,
            }
        },

        created() {
            this.list()
        },

        computed: {
            
            empty() {
                return !this.sessions || this.sessions.length == 0
            },
        },

        methods: {

            list() {
                axios.get(this.endpoint).then(resp => {          
                    this.sessions = resp.data.data
                })
            },

            date(session) {
                return this.moment(session.created_at).format('YYYY/MM/DD')
            },

            forgetNotification(session) {
                axios.delete(this.endpoint + '/sessions/' + session.id).then(resp => {          
                    this.list()
                })
            },

            openSummary(session) {
                this.$router.push({ name: 'log-session-summary',
                    params: { 
                        sessionId: session.id,
                        registrationId: session.registration.id,
                        simulationId: session.simulation.id,
                        groupId: 0,
                    }
                })
            },

            openOrEditLearner(learner, session) {
                if (!learner.state.published) {
                    this.editLearner(learner, session)
                } else {
                    this.openLearner(learner, session)
                }
            },

            openLearner(learner, session) {
                this.$router.push({ name: 'dashboard-learner-simulation',
                    params: { 
                        learnerId: learner.id,
                        registrationId: session.registration.id,
                        simulationId: session.simulation.id,
                    }
                })
            },

            editLearner(learner, session) {
                this.$router.push({ name: 'dashboard-learner-simulation-edit',
                    params: { 
                        learnerId: learner.id,
                        registrationId: session.registration.id,
                        simulationId: session.simulation.id,
                    }
                })
            }
        }
    }
</script>

<style scoped>

    .card >>> td {
        padding-right: 0;
    }
    .card >>> td.avatar-cell {
        padding-left: 2rem;
    }
    .card >>> td.actions {
        padding-left: 0;
        padding-right: 1rem;
    }
    .text-warning {
        color: #ff9d00 !important;
    }

</style>